import {Component, OnInit} from "@angular/core";
import {User} from "../shared/user/user.model";
import {ProfileService} from "../profile/profile.service";
import {ToastService} from "../../app/core/toast.service";
import {AppAuth} from "../../app/core/auth";
import {AlertController} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "../shared/user/user.service";
@Component({
  templateUrl: 'users.page.html',
})
export class UsersPage implements OnInit {
  users: User[] = [];

  constructor(
    private profileService: ProfileService,
    private toast: ToastService,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private userService: UserService,
    public auth: AppAuth
  ) {}

  ngOnInit() {
    this.profileService.getOrganisationUsers()
      .subscribe(users => this.users = users);
  }

  updateUserStatus(user){
    this.profileService.updateUsersStatus(user)
      .subscribe(success => this.toast.show(success.message));
  }

  showInvitePrompt() {
    let prompt = this.alertCtrl.create({
      title: this.translate.instant('invite_modal.title'),
      message: this.translate.instant('invite_modal.invite_user_by_email'),
      inputs: [
        {
          name: 'email',
          placeholder: this.translate.instant('invite_modal.invited_users_email')
        }
      ],
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('invite_modal.invite_user'),
          handler: (inputData) => {
            if (!inputData.email) {
              return false;
            }
            prompt.dismiss()
              .then(() => this.invite(inputData.email));
            return false;
          }
        }
      ]
    });
    prompt.present();
  }

  invite(email){
    this.userService.invite(email)
      .subscribe(success => {
        this.toast.show(success.message);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/users.page.ts